export default __webpack_public_path__ + "02e1f22afe0af9d1663ec31ba9cb393b.svg";